import { useT } from '../../i18n';
import { cx } from './cx';

export function Spinner({ className }: { className?: string }) {
  const { t } = useT();
  return (
    <span
      role="status"
      aria-label={t('common.loading')}
      className={cx(
        'inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent',
        className,
      )}
    />
  );
}
